import { EnumConfig } from 'angular-odata';

//#region ODataApi Imports
import { DataType } from './datatype.enum';
//#endregion

export const DataTypeConfig = {
  name: "DataType",
  members: DataType
} as EnumConfig<DataType>;